<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#EB5757"/>
    <path d="M15 17V19C11.9749 19.8874 10.2494 19.9333 7 19V17C10.1742 17.8923 11.9457 17.823 15 17ZM10 6.99V15H12V6.99H15L11 3L7 6.99H10Z" fill="#F2F2F2"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.59 12.09L16.5 14.5L15.41 12.09L13 11L15.41 9.91L16.5 7.5L17.59 9.91L20 11L17.59 12.09Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "NivelElevado"
}
</script>

<style scoped>

</style>
